import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

export default function EmailKnowledgeBase() {

  useEffect(() => {
    // Redirect to new location
    navigate(`/ai/actors/${actorId}/email-knowledge-base`, { replace: true });
  }, [actorId, navigate]);

  return null;
}
